const Replacement = ( { name } ) => {
  return (
    <span className='lead'>
      ( + { name } )
    </span>
  )
}

export default Replacement